import { Pipe, PipeTransform } from '@angular/core';

interface DisplayEnum {
  label: string;
  name: string;
}

@Pipe({
  name: 'enumToArray',
})
export class EnumToArrayPipe implements PipeTransform {
  transform(data: Object) {
    let keys = Object.keys(data);
    let underscoreMatch = new RegExp(/[_]/, 'g');

    let displayEnums: Array<DisplayEnum> = [];

    keys = keys.slice(keys.length / 2);

    keys.forEach((key) => {
      key = key.trim();

      displayEnums.push({
        label: key.replace(underscoreMatch, ' '),
        name: key,
      });
    });

    return displayEnums;
  }
}
